/**
 * Constantes de configuración de la API
 */

/** Dominio base de la API (sin barra final) */
export const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:8080";

/** Prefijo opcional para todas las rutas (ej: "api/v1") */
export const API_PREFIX = "";

/** Headers por defecto para todas las peticiones */
export const DEFAULT_HEADERS = {
  "Content-Type": "application/json",
  Accept: "application/json",
};

/**
 * Configuración para peticiones cross-origin.
 * No usamos withCredentials porque la auth es por JWT en Authorization header.
 * Si el backend usara cookies de sesión, habría que activar withCredentials
 * y que el backend responda con Access-Control-Allow-Origin: <origen concreto>
 * y Access-Control-Allow-Credentials: true (no puede usar '*' con credenciales).
 */
export const CORS_CONFIG = {};

/** Timeout por defecto para las peticiones (ms) */
export const REQUEST_TIMEOUT = 30000;
